import { Component, ElementRef, RendererFactory2, OnInit, Input, Output, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IcepanelComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelService } from 'projects/icemedx-lib/src/components/icepanel/icepanel.service';
import { IcepanelContainerComponent } from 'projects/icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { IcecontrolSettings, IcepanelsectionSettings, IcepanelSettings } from 'projects/icemedx-lib/src/components/models/icesettings';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { IcematgridComponent } from 'projects/icemedx-lib/src/components/icepanel/icematgrid.component';

@Component({
  selector: 'iceexpansionpanel',
  templateUrl: './iceexpansionpanel.component.html',
  styleUrls: ['./iceexpansionpanel.component.scss'],
  providers: [IcepanelComponent]
})
export class IceexpansionpanelComponent extends IcepanelComponent implements OnInit {
  // Input Members
  @Input() stepAssignment: number = -1;
  @Input() description: string = "";

  constructor(targetRef: ElementRef,
      @Inject(IcepanelContainerComponent) parent: IcepanelContainerComponent,
      panelSvc: IcepanelService,
      rendererFactory: RendererFactory2) {

    super(targetRef, parent, panelSvc, rendererFactory);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  getStep() {
    return super.getContainer().currentExpansionStep;
  }

  setStep() {
    if (this.stepAssignment < 0) {
      this.stepAssignment = super.getContainer().registerNewStep();
    }
    super.getContainer().setStep(this.stepAssignment);
    if (this.stepAssignment > 0) {
      super.onHeaderActionClick(event, null);
    }
  }

  private allowedToContinue() {
    let cont: boolean = true;
    let panel: IcepanelSettings = super.getPanel();
    let form: FormGroup = panel.getForm();
    if (form != null && false == form.valid) {
      cont = false;
    }
    return cont;
  }

  onNextStep(event) {
    let isAllowedToContinue = this.allowedToContinue();
    if (isAllowedToContinue) {
      super.onHeaderActionClick(event, null);
      super.getContainer().nextStep();
    } else {
      super.getContainer().buttonClick.emit({ isAllowedToContinue, button: event.currentTarget.innerText });
    }
  }

  onPrevStep(event) {
    super.onHeaderActionClick(event, null);
    super.getContainer().prevStep();
  }

  onCompleteStep(event) {
    let isAllowedToContinue = this.allowedToContinue();
    if (isAllowedToContinue) {
      super.onFormSubmit(event);
      super.getContainer().nextStep();
    } else {
      super.getContainer().controlClick.emit({ isAllowedToContinue, button: event.currentTarget.innerText });
    }
  }

  isFinalStep() {
    return super.getContainer().isFinalStep();
  }
}
